module.exports = __webpack_public_path__ + "static/media/background-steel.b212a74f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-steel.jpg
// module id = 1017
// module chunks = 0